import React from 'react';
import { Modal, Input, Form, Select, Row, Col, Alert, Divider } from 'antd';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idPadre: values.idPadre,
                    nombre: values.nombre,
                    codigo: values.codigoPadre + '' + values.codigo,
                    idNivel: values.idNivel.key,
                    numero: 1,
                    //codigoEstablecimiento: values.codigotipoEstablecimiento.key
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('idPadre', { initialValue: this.props.formValues.idPadre });
        getFieldDecorator('codigoPadre', { initialValue: this.props.formValues.codigoPadre });

        return (
            <Modal
                title={this.props.formValues.asignar ? "Asignar Categoria" :
                    this.props.formValues.id === 0 ? "Registrar Categoria" : "Modificar Categoria"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>

                    {this.props.formValues.asignar ?
                        <Row gutter={16}>
                            <Divider>Ruta o Nivel</Divider>

                            <Col className="gutter-row" span={24}>
                                <Alert showIcon message={this.props.formValues.label} type="info" />
                            </Col>
                        </Row> : null
                    }

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Codigo">
                                {getFieldDecorator('codigo', {
                                    initialValue: this.props.formValues.codigo,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar codigo"
                                        autoComplete="off"
                                        maxLength={20}
                                        addonBefore={this.props.formValues.asignar ? this.props.formValues.codigoPadre : ''}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Nivel">
                                {getFieldDecorator('idNivel', {
                                    initialValue: this.props.formValues.idNivel > 0 ?
                                        { key: this.props.formValues.idNivel } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione nivel"}
                                        disabled={this.props.formValues.id > 0 ? true : false}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.niveles.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    {/* 
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Tipo Almacen">
                                {getFieldDecorator('codigotipoEstablecimiento', {
                                    initialValue: this.props.formValues.codigotipoEstablecimiento > 0 ?
                                        { key: this.props.formValues.codigotipoEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione establecimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.tipoEstablecimientos.map(item => (
                                            <Option key={item.codigo} value={item.codigo} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row> */}
                </Form>
            </Modal >
        );
    }
}
export default Form.create()(FormModal)